import type HeroIsoArtwork from "./HeroIsoArtwork";

// A client-side navigation to the page has no server markup to keep, so the browser renders the
// artwork itself. The page's route loader awaits this on the client, so the artwork's code is
// loaded (and only then) before that navigation renders.
let clientArtwork: typeof HeroIsoArtwork | undefined;
let clientArtworkPromise: Promise<typeof HeroIsoArtwork> | undefined;

export const loadHeroIsoArtwork = (): Promise<typeof HeroIsoArtwork> => {
  clientArtworkPromise ??= import("./HeroIsoArtwork").then(({ default: artwork }) => {
    clientArtwork = artwork;
    return artwork;
  });
  return clientArtworkPromise;
};

/** The artwork once `loadHeroIsoArtwork` has loaded it. */
export const getLoadedHeroIsoArtwork = () => clientArtwork;
